import React, { useEffect, useState } from "react";
import { ToastContainer, toast } from "react-toastify";
import {
  API_TOKEN_NAME,
  USER_ID,
  USER_LOCAL_ID,
  USER_ROLE,
  USER_EMAIL,
  LOGIN_PHONE_NUMBER,
  PATIENT_NAME,
  SEARCH_SELECTED_DOC_ID,
  SEARCH_SELECTED_DOC_NAME,
  SCHEDULE_DATE,
  IMAGE_URL,
} from "../../constants";
import { scAxiosAdmin } from "../..";
import "react-toastify/dist/ReactToastify.css";
import { startUserSession } from "../../userSession";
import uhlcare_logo from "../../images/uhlcare-logo.webp";
import uhl_logo from "../../images/UHL (2).webp";
import medix_logo from "../../images/medix-logo.webp";
import ma_rashed_logo from "../../images/ma rashed hospital.webp";
import mainlogo from "../../images/main-logo.webp";
import { Link } from "react-router-dom";
import DatePicker from "react-datepicker";
import Loading from "../../images/Loading_icon.gif";
import Moment from "moment";
const ConfirmAppointmentAndRequestAppointmentParticularDoctorWithScheduleSelected =
  ({ scheduleReqData }) => {
    const [loading, setLoading] = useState(false);
    const [appointmentLoading, setAppointmentLoading] = useState(false);
    const [newDate, setNewDate] = useState("");
    const [slot, setSlot] = useState(null);
    const [selectedDoctorData, setSelectedDoctorData] = useState(null);
    const [bookingResponse, setBookingResponse] = useState();
    const [bookingRequestResponse, setBookingRequestResponse] = useState();
    const [disabled, setDisabled] = useState(true);

    useEffect(() => {}, []);

    const doctorData = scheduleReqData && scheduleReqData.doctorData;
    let dateName = null;
    let showDate = null;

    if (newDate) {
      dateName = new Date(newDate).toLocaleDateString("en-US", {
        weekday: "long",
      });
      showDate = Moment(newDate).format("LL");
    } else {
      dateName = new Date(scheduleReqData.PreferredDate).toLocaleDateString(
        "en-US",
        { weekday: "long" }
      );
      showDate = Moment(scheduleReqData.PreferredDate).format("LL");
    }

    let schedules = scheduleReqData.selectedSchedule;
    /* if (doctorData && dateName && doctorData.Schedule !== null) {
    const schedulesObject = doctorData.Schedule[0];
    if (dateName) {
      schedules = schedulesObject[dateName];
    }
  } */

    const handleSubmit = (event) => {
      event.preventDefault();
    };
    const handleScheduleAppointment = (type) => {
      const scheduleAppointmentPostData = {
        type: "book_appointment",
        doctor_id: scheduleReqData.DoctorID,
        user_patient_id: localStorage.getItem(USER_LOCAL_ID),
        appointment_date: scheduleReqData.PreferredDate,
        appointment_time: slot,
        patient_phone_number: localStorage.getItem(LOGIN_PHONE_NUMBER),
        amount: 1500.0,
        doctor_name: scheduleReqData.doctorData.doctor_name,
        patient_name: localStorage.getItem(PATIENT_NAME),
        doctor_fees: 1500.5,
      };
      const reqAppointmentPostData = {
        type: "request_appointment",
        doctor_id: scheduleReqData.DoctorID,
        user_patient_id: localStorage.getItem(USER_LOCAL_ID),
        appointment_date: scheduleReqData.PreferredDate,
        patient_phone_number: localStorage.getItem(LOGIN_PHONE_NUMBER),
        amount: 1500.0,
        doctor_name: scheduleReqData.doctorData.doctor_name,
        patient_name: localStorage.getItem(PATIENT_NAME),
        doctor_fees: 1500.5,
      };
      if (type === "schedule_appointment") {
        try {
          setAppointmentLoading(true);
          const req = scAxiosAdmin
            .post(`/appointments/request_new`, scheduleAppointmentPostData, {
              method: "post",
              headers: {
                Accept: "application/json",
                Authorization: "Bearer " + localStorage.getItem(API_TOKEN_NAME),
              },
            })
            .then((data) => {
              if (data.status === 201) {
                toast.success(
                  "Your request for an appointment is received. We will confirm shortly!!"
                );
                setBookingResponse(data.data.data);
                setAppointmentLoading(false);
              }
            })
            .catch((e) => {
              toast.error("Something went wrong!");
              setAppointmentLoading(false);
              console.log("your log output", e);
            });
        } catch (error) {
          toast.error("Something went wrong!");
          setAppointmentLoading(false);
        }
      }
      if (type === "request_appointment") {
        try {
          setAppointmentLoading(true);
          const req = scAxiosAdmin
            .post(`/appointments/request_new`, reqAppointmentPostData, {
              method: "post",
              headers: {
                Accept: "application/json",
                Authorization: "Bearer " + localStorage.getItem(API_TOKEN_NAME),
              },
            })
            .then((data) => {
              if (data.status === 201) {
                toast.success(
                  "Your request for an appointment is received. We will confirm shortly!!"
                );
                setBookingRequestResponse(data.data.data);
                setAppointmentLoading(false);
              }
            })
            .catch((e) => {
              toast.error("Something went wrong!");
              setAppointmentLoading(false);
              console.log("your log output", e);
            });
        } catch (error) {
          toast.error("Something went wrong!");
          setAppointmentLoading(false);
        }
      }
    };

    //
    //   useEffect(() => {
    //     const getSingleDoctor = (data) => {
    //       try {
    //         setLoading(true);
    //         const req = scAxiosAdmin
    //           .request(`/doctors/getsingledoctors/${scheduleReqData.DoctorID}`, {
    //             method: "get",
    //             headers: {
    //               Accept: "application/json",
    //               Authorization: "Bearer " + localStorage.getItem(API_TOKEN_NAME),
    //             },
    //           })
    //           .then((data) => {
    //             if (data.status === 200) {
    //               setDoctorData(data.data.data);
    //               setLoading(false);
    //             }
    //           })
    //           .catch((e) => {
    //             setLoading(false);
    //             console.log("your log output", e);
    //           });
    //       } catch (error) {
    //         setLoading(false);
    //       }
    //     };
    //     getSingleDoctor();
    //   }, [scheduleReqData.DoctorID]);
    return (
      <div
        className="offcanvas offcanvas-start"
        tabIndex={-1}
        id="ConfirmAppointmentAndRequestAppointmentParticularDoctorWithScheduleSelected"
        aria-labelledby="offcanvasExampleLabel"
        // style={{ visibility: "visible" }}
      >
        <div className="offcanvas-header">
          <h5 className="offcanvas-title" id="offcanvasExampleLabel">
            {" "}
          </h5>
          <button
            type="button"
            className="btn-close text-reset"
            data-bs-dismiss="offcanvas"
            aria-label="Close"
            onClick={() => {
              setNewDate(""), setSlot(null);
              location.reload();
            }}
          />
        </div>
        <div className="offcanvas-body">
          {/* <div className="row d-flex justify-content-around" id="logos">
          <div className="col-2 ">
            <img src={uhlcare_logo} alt="uhlcare-logo" />
          </div>
          <div className="col-2">
            <img src={mainlogo} alt="medix-logo" />
          </div>
          <div className="col-2">
            <img src={uhl_logo} alt="uhl-logo" />
          </div>
          <div className="col-2">
            <img src={medix_logo} alt="medix-logo" />
          </div>
          <div className="col-2">
            <img src={ma_rashed_logo} alt="medix-logo" />
          </div>
        </div> */}
          <div className="left-offcanvas">
            <h4 style={{ color: "#187979" }}>Book Appointment</h4>
            <p className="goback">
              <button
                variant="primary"
                // data-bs-toggle="offcanvas"
                // data-bs-target="#BookAppointMentParticularDoctorPopUp"
                // aria-controls="BookAppointMentParticularDoctorPopUp"
                onClick={() => {
                  setNewDate(""), setSlot(null);
                  location.reload();
                }}
                style={{ background: "none", border: "none" }}
              >
                <i className="fa-solid fa-circle-left" /> Go Back &amp; Reselect
                your Doctor
              </button>
            </p>
            <div className="sd-container">
              <h6 className="timer">
                {/* {schedule_data} &nbsp;&nbsp;{" "} */}
                {showDate}
                <input
                  type="date"
                  className="change_schedule_date"
                  name="change_schedule_date"
                  id="change_schedule_date"
                  value={newDate}
                  onChange={(e) => setNewDate(e.target.value)}
                  // min={newcurrentdate}
                />
                <i className="moz-cover-clear"></i>
                <span className="open-button">
                  <button type="button">📅</button>
                </span>
              </h6>
            </div>
            <form
              onSubmit={handleSubmit}
              className="needs-validation"
              noValidate
            >
              <div className="row mt-4">
                <div className="col-12 sp-0-0">
                  <div className="doctor-list Dr-Reazur">
                    <div
                      className="row"
                      onClick={() => setSelectedDoctorData(doctorData)}
                    >
                      <div className="col-4 sp-0-1 left-0">
                        {doctorData ? (
                          <img
                            src={
                              IMAGE_URL +
                              "/DoctorProfileImg/" +
                              doctorData.doctor_profile
                            }
                            alt="doctor profile"
                          />
                        ) : (
                          <img
                            src="https://static.vecteezy.com/system/resources/thumbnails/003/337/584/small/default-avatar-photo-placeholder-profile-icon-vector.jpg"
                            alt="doc"
                          />
                        )}
                      </div>
                      <div className="col-8" id="dr">
                        <h5>{doctorData.doctor_name}</h5>
                        <p>
                          {doctorData.doctor_degree !== ""
                            ? doctorData.doctor_degree
                            : ""}
                        </p>
                        <p className="mt-2">
                          {doctorData.doctor_fees !== "" ? (
                            <strong style={{ color: "#fb6201" }}>
                              BDT {doctorData.doctor_fees}
                            </strong>
                          ) : (
                            <strong></strong>
                          )}
                        </p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <div className="row mt-4" id="time-date">
                <div className="col-12">
                  {schedules !== null && schedules !== undefined ? (
                    schedules.split(",").map((schedule_time) => {
                      return (
                        <div
                          className="doctor_schedule_section"
                          key={schedule_time}
                          style={{ marginBottom: "5px" }}
                        >
                          <input
                            type="radio"
                            className="schedule_time"
                            id="schedule_date_time"
                            name="schedule_date_time"
                            defaultValue={schedule_time}
                            value={schedule_time}
                            onChange={(e) => {
                              if (slot !== e.target.value) {
                                // Only set the slot if it's not already selected
                                setSlot(e.target.value);
                              }
                            }}
                          />
                          <div className="btn-links color-check text-center">
                            {schedule_time} {showDate}
                          </div>
                        </div>
                      );
                    })
                  ) : (
                    <p>No slots available!</p>
                  )}
                  {appointmentLoading ? (
                    <img src={Loading} alt="Loading" />
                  ) : (
                    ""
                  )}
                </div>
              </div>
              <div className="row mt-3">
                <div className="col-12">
                  {schedules !== null && schedules !== undefined ? (
                    <button
                      variant="primary"
                      type="submit"
                      className="btn-links appointment-new"
                      id="Schedule"
                      onClick={() =>
                        handleScheduleAppointment("schedule_appointment")
                      }
                      style={{
                        backgroundColor: slot ? "rgb(246, 130, 31)" : "",
                      }}
                    >
                      Schedule Appointment
                    </button>
                  ) : (
                    <button
                      variant="primary"
                      type="submit"
                      className="btn-links appointment-new"
                      id="Schedule"
                      onClick={() =>
                        handleScheduleAppointment("request_appointment")
                      }
                    >
                      Request Appointment
                    </button>
                  )}
                </div>
              </div>
            </form>
          </div>
        </div>
        <ToastContainer autoClose={5000} />
      </div>
    );
  };

export default ConfirmAppointmentAndRequestAppointmentParticularDoctorWithScheduleSelected;



// WEBPACK FOOTER //
// ./src/component/frontend/ConfirmAppointmentAndRequestAppointmentParticularDoctorWithScheduleSelected.js